//src/components/TradersOutlet.jsx
import React, { useState } from "react";
import styled from "styled-components";
import { Outlet } from "react-router-dom";
import TradersNavbar from "./TradersNavbar";
import TradersSidebar from "./TradersSidebar";

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 60px;
`;

const BodyWrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;

const MainContent = styled.main`
  margin-left: 220px;
  padding: 2rem;
  width: 100%;

  @media only screen and (max-width: 768px) {
    margin-left: 0;
    padding: 1rem;
  }
`;

const SidebarToggle = styled.button`
  display: none;

  @media only screen and (max-width: 768px) {
    display: block;
    position: fixed;
    top: 70px;
    left: 10px;
    padding: 8px 14px;
    background: teal;
    color: white;
    border: none;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    z-index: 900;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  }
`;

const Backdrop = styled.div`
  display: none;

  @media only screen and (max-width: 768px) {
    display: ${(props) => (props.open ? "block" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1400;
  }
`;

export default function SkillsOutlet() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <LayoutContainer>
      <TradersNavbar />

      <SidebarToggle onClick={() => setSidebarOpen(true)}>
        📘 Categories
      </SidebarToggle>
      <Backdrop open={sidebarOpen} onClick={() => setSidebarOpen(false)} />

      <BodyWrapper>
        <TradersSidebar
          open={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />
        <MainContent>
          <Outlet />
        </MainContent>
      </BodyWrapper>
    </LayoutContainer>
  );
}
